var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.languages,"item-text":"name","item-value":"languageId"}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }